<template>
  <div>
    <PageAllow controller="StockOuts" action="view" />
    <Breadcrumbs :items="items" />
    <v-sheet class="transparent-background-color">
      <v-sheet class="transparent-background-color py-4 mx-4">
        <v-expansion-panels v-model="panelsDetail" multiple accordion>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <v-card-title class="ms-n4 py-0">
                {{ $t("StockOutsDetail.title") }}
                <v-chip
                  class="ms-4 mt-1"
                  small
                  label
                  :color="stock_out.status | outStatusColor"
                  :text-color="stock_out.status | outStatusTextColor"
                >
                  {{ stock_out.status | outStatusText }}
                </v-chip>
                <v-spacer></v-spacer>
                <v-sheet
                  class="pt-1 transparent-background-color d-inline-block"
                >
                  <v-btn
                    small
                    dark
                    color="print"
                    class="px-2 me-2 mb-1 elevation-1"
                    @click.stop="Export()"
                  >
                    <!-- <v-icon x-small class="pe-1">fa-sync-alt</v-icon> -->
                    {{ $t("EconomiesDetail.export") }}
                  </v-btn>
                </v-sheet>
              </v-card-title>
            </v-expansion-panel-header>
            <v-divider></v-divider>
            <v-expansion-panel-content>
              <v-row no-gutters class="mt-4 table-style">
                <v-col cols="12" md="4">
                  <v-card class="pa-2 text-no-wrap" outlined tile>
                    <span class="secondary--text">
                      {{ $t("StockOutsDetail.Fields.stock_order_code")
                      }}{{ $t("Global.colon") }}
                    </span>
                    {{ stock_out.stock_order_code }}
                  </v-card>
                </v-col>
                <v-col cols="12" md="4">
                  <v-card class="pa-2 text-no-wrap" outlined tile>
                    <span class="secondary--text">
                      {{ $t("EconomiesDetail.Fields.created")
                      }}{{ $t("Global.colon") }}
                    </span>
                    {{ stock_out.created | formatTime }}
                  </v-card>
                </v-col>
                <v-col cols="12" md="4">
                  <v-card class="pa-2 text-no-wrap" outlined tile>
                    <span class="secondary--text">
                      {{ $t("StockOutsDetail.Fields.creater")
                      }}{{ $t("Global.colon") }}
                    </span>
                    {{ stock_out.creater ? stock_out.creater.name : "" }}
                  </v-card>
                </v-col>
                <v-col cols="12" md="4">
                  <v-card class="pa-2 text-no-wrap" outlined tile>
                    <span class="secondary--text">
                      {{ $t("StockOutsDetail.Fields.name",[$consts.shopName()])
                      }}{{ $t("Global.colon") }}
                    </span>
                    {{ accountName
                    }}{{ stock_out.stock ? stock_out.stock.name : "" }}
                  </v-card>
                </v-col>
                <v-col cols="12" md="8">
                  <v-card class="pa-2 text-no-wrap" outlined tile>
                    <span class="secondary--text">
                      {{ $t("StockOutsDetail.Fields.memo")
                      }}{{ $t("Global.colon") }}
                    </span>
                    {{ stock_out.memo }}
                  </v-card>
                </v-col>
                <v-col cols="12" md="12">
                  <v-card class="pa-2 text-no-wrap" outlined tile>
                    <span class="secondary--text">
                      {{ $t("StockOutsDetail.Fields.image_url")
                      }}{{ $t("Global.colon") }}
                    </span>
                    <span v-if="stock_out.image_url">
                      <v-avatar
                        tile
                        color="bgGrey"
                        style="vertical-align: top"
                        v-for="i in stock_out.image_url"
                        :key="i"
                      >
                        <v-img
                          alt="Avatar"
                          :src="i"
                          @click.stop="$showFullscreenImages([i])"
                        />
                      </v-avatar>
                    </span>
                  </v-card>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel>
            <v-expansion-panel-header class="py-0">
              <v-tabs v-model="tab" background-color="transparent">
                <v-tab
                  @click.stop="
                    tab = 0;
                    panelsDetail.find((p) => p == 1)
                      ? null
                      : panelsDetail.push(1);
                  "
                >
                  {{ $t("StockOutsDetail.activities.title") }}
                </v-tab>
              </v-tabs>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-tabs-items v-model="tab">
                <v-tab-item>
                  <v-card flat>
                    <v-data-table
                      :headers="activitiesHeaders"
                      :items="activities_details"
                      class="elevation-0"
                      disable-pagination
                      hide-default-footer
                    >
                      <template v-slot:item.created="{ item }">
                        {{ item.created | formatTime }}
                      </template>
                    </v-data-table>
                  </v-card>
                </v-tab-item>
              </v-tabs-items>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-sheet>
      <div class="px-4 pb-4">
        <v-card class="px-4">
          <v-toolbar flat class="transparent-background-color">
            <v-card-title class="ms-n4 py-0">
              {{ $t("StockOutsDetail.title") }}
              <v-spacer />
            </v-card-title>
          </v-toolbar>
          <v-divider />
          <v-data-table
            :headers="headers"
            :items="stock_order_details"
            :search="search"
            multi-sort
            disable-pagination
            hide-default-footer
            class="pb-2"
          >
            <template v-slot:top>
              <v-toolbar
                flat
                class="transparent-background-color"
                align-self="center"
              >
                <v-row no-gutters class="me-n3">
                  <span class="caption secondary--text pt-2">
                    {{
                      $t(
                        "$vuetify.dataFooter.pageText",
                        stock_order_details
                          ? [
                              stock_order_details.length > 0 ? 1 : 0,
                              stock_order_details.length,
                              stock_order_details.length,
                            ]
                          : [0, 0, 0]
                      )
                    }}
                  </span>
                  <v-row no-gutters>
                    <v-spacer />
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field
                        v-model="search"
                        clearable
                        :label="$t('Search.filter')"
                        hide-details
                      />
                    </v-col>
                  </v-row>
                </v-row>
              </v-toolbar>
              <!-- <h3>
                <span
                  v-if="stock_out.status == 3"
                  class="d-flex flex-row-reverse"
                >
                  {{ $t("DeliveryDetail.sum") }}{{ $t("Global.colon") }}
                  {{ $t("Global.money") }}{{ stock_out.total_price }}
                </span>
                <span v-else class="d-flex flex-row-reverse">
                  {{ $t("DeliveryDetail.sum") }}{{ $t("Global.colon") }}
                  {{ $t("Global.money") }}{{ stock_out.total_confirm_price }}
                </span>
              </h3> -->
            </template>

            <template v-slot:footer>
                <v-row>
                  <v-spacer />
                  <v-col cols="12" sm="6" md="3">
                    <v-list-item>
                      <v-list-item-content>
                        <span class="secondary--text font-weight-bold">
                          {{ $t("DeliveryDetail.sum") }}
                        </span>
                      </v-list-item-content>
                      <v-list-item-content class="align-end text-end">
                        <span
                          v-if="stock_out.status == 3"
                          class="accent--text font-weight-bolde"
                        >
                          {{ $t("Global.money") }}{{ stock_out.total_price }}
                        </span>
                        <span v-else class="accent--text font-weight-bolde">
                          {{ $t("Global.money") }}{{ stock_out.total_confirm_price }}
                        </span>
                      </v-list-item-content>
                    </v-list-item>
                  </v-col>
                </v-row>
              </template>

            <template v-slot:item.price="{ item }">
              {{ $t("Global.money") }}{{ item.price | formatMoney }}
            </template>
          </v-data-table>
        </v-card>
      </div>
    </v-sheet>
  </div>
</template>

<script>
import i18n from "@/i18n";
import { mapState } from "vuex";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";

import StockOuts from "@/api/stock_outs";

export default {
  components: {
    PageAllow,
    Breadcrumbs,
  },

  data: () => ({
    panelsDetail: [0],
    Detail: [0],
    stock_out: {},
    tab: null,
    search: "",
    activities_details: [],
    stock_order_details: [],
  }),

  computed: {
    // eslint-disable-next-line vue/return-in-computed-property
    accountName() {
      if (this.accountInfo) return this.accountInfo.account_name;
    },
    items() {
      var items = [
        {
          text: i18n.t("Nav.home"),
          disabled: false,
          href: "/home",
        },
        {
          text: i18n.t("Nav.stockOuts"),
          disabled: false,
          href: "/stock-outs",
        },
        {
          text: i18n.t("Nav.stockOutsIndex"),
          disabled: true,
          href: "/stock-outs",
        },
      ];
      if (this.stock_out && this.stock_out.stock_order_code) {
        items.push({
          text: this.stock_out.stock_order_code,
          disabled: false,
          accent: true,
        });
      }
      return items;
    },
    activitiesHeaders: () => [
      {
        text: i18n.t("StockOutsDetail.activities.time"),
        align: "start",
        sortable: false,
        value: "created",
      },
      {
        text: i18n.t("StockOutsDetail.activities.content"),
        align: "start",
        sortable: false,
        value: "content",
      },
      {
        text: i18n.t("StockOutsDetail.activities.operater_name"),
        align: "start",
        sortable: false,
        value: "operater_name",
      },
    ],
    headers: () => [
      {
        text: i18n.t("StockOutsDetail.Fields.material_category"),
        align: "start",
        sortable: false,
        value: "category_name",
      },
      {
        text: i18n.t("StockOutsDetail.Fields.material_code"),
        align: "start",
        sortable: false,
        value: "material_code",
      },
      {
        text: i18n.t("StockOutsDetail.Fields.material_name"),
        align: "start",
        sortable: false,
        value: "material_name",
      },
      {
        text: i18n.t("StockOutsDetail.Fields.standard"),
        align: "start",
        sortable: false,
        value: "standard_name",
      },
      {
        text: i18n.t("StockOutsDetail.Fields.unit"),
        align: "start",
        sortable: false,
        value: "unit",
      },
      //   单价
      {
        text: i18n.t("StockOutsDetail.Fields.price"),
        align: "end",
        sortable: false,
        value: "price",
      },
      // 申请出库量
      {
        text: i18n.t("StockOutsDetail.Fields.order_num"),
        align: "end",
        sortable: false,
        value: "order_num",
      },
      // 核定出库量
      {
        text: i18n.t("StockOutsDetail.Fields.confirm_num"),
        align: "end",
        sortable: false,
        value: "confirm_num",
      },
      // 实际出库量
      {
        text: i18n.t("StockOutsDetail.Fields.out_num"),
        align: "end",
        sortable: false,
        value: "out_num",
      },
    ],
    ...mapState(["accountInfo"]),
  },

  mounted() {
    this.getEconomyFromAPI();
  },

  methods: {
    getEconomyFromAPI() {
      StockOuts.fetchOne(this.$route.params.id, { order_activity: 1 }).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.stock_out = response.data.stock_out;

            this.activities_details = response.data.order_activities;

            this.stock_order_details =
              response.data.stock_out.stock_order_details;
          }
        }.bind(this)
      );
    },

    Export() {
      StockOuts.exportOne(Object.assign(this.$route.params.id));
    },
  },
};
</script>

<style>
</style>